var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepByStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 220 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 140,
    width: 40,
    height: 20,
    rx: 4,
    fill: "#2E9F3E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 120,
    width: 40,
    height: 20,
    rx: 4,
    fill: "#2E9F3E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 100,
    width: 40,
    height: 20,
    rx: 4,
    fill: "#2E9F3E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 80,
    width: 40,
    height: 20,
    rx: 4,
    fill: "#F2994A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepByStep);
export default __webpack_public_path__ + "static/media/step_by_step.f6c27a85d2ccb9788c8c2d3d8cef5e6e.svg";
export { ForwardRef as ReactComponent };